"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _Slider = _interopRequireDefault(require("rc-slider/lib/Slider"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _VideoTime = _interopRequireDefault(require("./VideoTime"));

var _elMeasurements = require("../../../constants/elMeasurements");

require("rc-slider/assets/index.css");

require("../styles/_controls.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Controls = /*#__PURE__*/function (_Component) {
  _inherits(Controls, _Component);

  var _super = _createSuper(Controls);

  function Controls() {
    var _this;

    _classCallCheck(this, Controls);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "conditionalAction", (0, _lodash2.default)(function (action, condition) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      return condition ? props[action] : void 0;
    }, function (action, condition) {
      return "".concat(action, "-").concat(condition);
    }));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var zoom = parseInt(value, 10);

      _this.setState({
        zoomLevel: zoom
      });

      var onChangeZoomSeconds = _this.props.onChangeZoomSeconds;
      onChangeZoomSeconds(Math.ceil(0.6 / (zoom / _elMeasurements.TIMELINE_LABEL_WIDTH)));
    });

    _this.state = {
      zoomLevel: 50
    };
    return _this;
  }

  _createClass(Controls, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var zoomLevel = this.state.zoomLevel;
      return nextState.zoomLevel !== zoomLevel || !(0, _lodash.default)(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var zoomLevel = this.state.zoomLevel;
      var _this$props = this.props,
          playing = _this$props.playing,
          totalDuration = _this$props.totalDuration,
          hasClips = _this$props.hasClips;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "controls"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "controls__comments"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "controls__container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "controls__play-info"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "controls__play-info__status"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: playing ? 'play' : 'pause',
        size: 10,
        color: "white"
      }), /*#__PURE__*/_react.default.createElement("p", null, playing ? 'PLAYING' : 'PAUSED')), /*#__PURE__*/_react.default.createElement(_VideoTime.default, {
        totalDuration: totalDuration
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "controls__buttons"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        onClick: this.conditionalAction('onChapterBack', hasClips),
        className: "controls__buttons__c-back",
        size: 20,
        name: "previous",
        color: "white"
      }), playing ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        onClick: this.conditionalAction('onPause', hasClips && playing),
        className: "controls__buttons__pause",
        name: "pause",
        color: "white"
      }) : /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        onClick: this.conditionalAction('onPlay', hasClips),
        className: "controls__buttons__play",
        name: "play",
        color: "white"
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        onClick: this.conditionalAction('onChapterForward', hasClips),
        className: "controls__buttons__c-forward",
        size: 20,
        name: "skip",
        color: "white"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "controls__zoom"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "minimum",
        size: 10,
        color: "white"
      }), /*#__PURE__*/_react.default.createElement(_Slider.default, {
        min: 1,
        max: 100,
        value: zoomLevel,
        className: "controls__zoom__slider",
        onChange: this.onChange
      }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
        name: "maximum",
        size: 20,
        color: "white"
      }))));
    }
  }]);

  return Controls;
}(_react.Component);

exports.default = Controls;